import { render, staticRenderFns } from "./AddUserPromoCode.vue?vue&type=template&id=ef4ccf16&scoped=true&"
import script from "./AddUserPromoCode.vue?vue&type=script&lang=js&"
export * from "./AddUserPromoCode.vue?vue&type=script&lang=js&"
import style0 from "./AddUserPromoCode.vue?vue&type=style&index=0&id=ef4ccf16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4ccf16",
  null
  
)

export default component.exports